import { createSelector } from 'reselect'

const getState = state => state.Works

const getFetchRequest = state => getState(state).fetchWorksRequest

const getWorksAssessmentFileId = state =>
  state.Works.assessmentFile && state.Works.assessmentFile.id
const getWorksAssessmentFileTitle = state =>
  (state.Works.assessmentFile && state.Works.assessmentFile.title) || '-'
const getWorksAssessmentFileStudent = state =>
  state.Works.assessmentFile && state.Works.assessmentFile.student_types[0]
const getWorksAssessmentFilePolicy = state =>
  state.Works.assessmentFile && state.Works.assessmentFile.policy

const getWorks = state => getState(state).works

const getWorksMap = createSelector(
  [getWorks],
  works => (!works ? {} : works.entities.works)
)

const getWorksResult = createSelector(
  [getWorks],
  works => (!works ? [] : works.result)
)

const getWorksCount = createSelector(
  [getWorksResult],
  works => works.length
)

const getWorksList = createSelector(
  [getWorksResult, getWorksMap],
  (result, worksMap) => result.map(id => worksMap[id])
)

const getWork = (state, id) => (id ? getWorksMap(state)[id] : [])

const getSelectedWorkId = state => getState(state).selectedWorkId

const getMediaKey = state => getState(state).mediaKey

const getAddWorksDialog = state => getState(state).addWorksDialog

export {
  getFetchRequest,
  getWorksAssessmentFileTitle,
  getWorksAssessmentFileStudent,
  getWorksList,
  getWorksCount,
  getWork,
  getSelectedWorkId,
  getMediaKey,
  getAddWorksDialog,
  getWorksAssessmentFileId,
  getWorksResult,
  getWorksAssessmentFilePolicy
}
